import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { ListIconGrey } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';

interface EPScenarioReviewDueProps {
  assessment: {
    id: string;
  };
  scenario: {
    id: string;
    name: string;
  };
  isToday?: boolean;
}

export const EPScenarioReviewDue: React.FC<EPScenarioReviewDueProps> = ({ assessment, scenario, isToday }) => {
  const isPast = !isToday;
  return (
    <Base
      iconComponent={<ListIconGrey />}
      constentComponent={
        <Text $isPast={isPast}>
          Risk Scenario{' '}
          <Link
            to={`/risk-assessments/${assessment.id}/scenario/${scenario.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Scenario'],
                  params: {
                    id: scenario.id,
                  },
                },
                tags: ['TIMELINE', 'SCENARIO'],
              })
            }
          >
            <TextLink $isPast={isPast}>{scenario.name}</TextLink>
          </Link>{' '}
          was due for review.
        </Text>
      }
    />
  );
};
